import './styles.scss'

export const SingleRowTextLoading = ({ className="", ...rest }) => {
  return (
    <span className={`single-row-text-loading ${className}`} {...rest} ></span>
  )
}
